import { TrendingUp, Sparkles } from "lucide-react";
import { RadialScore, MetricCard, SectionHeading } from "./ResultsPrimitives";

export default function ScoreOverview({ analysis }) {
  const breakdown = analysis.viral_breakdown ? Object.entries(analysis.viral_breakdown) : [];
  return (
    <section data-testid="score-overview" className="space-y-6">
      <div className="relative overflow-hidden rounded-3xl border border-purple-400/25 bg-brand-card shadow-[0_0_0_1px_rgba(139,92,246,0.15),0_30px_80px_-40px_rgba(139,92,246,0.6)]">
        <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-purple-600/20 blur-[120px]" />
        <div className="pointer-events-none absolute -bottom-24 right-0 w-[320px] h-[320px] rounded-full bg-cyan-500/10 blur-[110px]" />
        <div className="relative p-6 md:p-10 grid lg:grid-cols-[auto_1fr] gap-8 items-center">
          <div className="flex flex-col items-center gap-3 mx-auto">
            <RadialScore id="viral" value={analysis.viral_score} size={220} stroke={14} />
          </div>
          <div className="text-center lg:text-left">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-purple-300 mb-2 flex items-center justify-center lg:justify-start gap-2">
              <Sparkles className="w-3.5 h-3.5" /> Resumen del análisis
            </p>
            <h3 className="text-2xl md:text-3xl font-extrabold text-vt-ink flex items-center justify-center lg:justify-start gap-2">
              <TrendingUp className="w-6 h-6 text-brand-red drop-shadow-[0_0_8px_rgba(224,0,0,0.6)]" /> Potencial Viral
            </h3>
            <p className="text-brand-text2 mt-2">Análisis completado con IA</p>

            {analysis.growth_potential_score && (
              <div data-testid="growth-potential-card" className="mt-6 inline-flex items-center gap-4 rounded-2xl border border-cyan-400/25 bg-brand-elevated/70 px-4 py-3 text-left">
                <RadialScore id="growth" value={analysis.growth_potential_score} size={84} stroke={7} compact />
                <div className="max-w-xs">
                  <p className="text-sm font-bold text-vt-ink">Potencial de Crecimiento</p>
                  <p className="text-xs text-brand-text2 leading-snug mt-0.5">Este score indica cuánto puede mejorar el video con las optimizaciones sugeridas</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {breakdown.length > 0 && (
        <div>
          <SectionHeading eyebrow="Nivel 2" title="Métricas clave" />
          <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {breakdown.map(([key, value], i) => <MetricCard key={key} name={key} value={value} index={i} />)}
          </div>
        </div>
      )}
    </section>
  );
}
